module.exports = __webpack_public_path__ + "img/AWeekOfHardLabor.24f52ba7.jpg";